<template>
  <div>
    <TopBar :pagetitle="pageTitle" :back-url="backurl" />
    <div class="teamRect">
      <div class="sanjiao" />
      <van-row>
        <van-col span="12" class="about">队伍宣言</van-col>
        <van-col span="12" class="textRight" />
      </van-row>
      <div class="talk">
        {{ data.declaration }}
      </div>
      <van-row>
        <van-col span="8" class="about">小队成员</van-col>
        <van-col v-if="data.myself" span="16" class="textRight about" style="color:#0092FA"><span @click="onShare">邀请好友加入，领取奖励</span></van-col>
      </van-row>
      <van-row gutter="10" class="iconRect">
        <van-col v-for="(item,index) in data.memberList" :key="index" span="8">
          <div class="imgRect">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAAAFnRFWHRDcmVhdGlvbiBUaW1lADA2LzI3LzE5+t0wZgAAAA5JREFUCJlj+H+AATcCAAdSEXeho034AAAAAElFTkSuQmCC">
            <div class="imgEmptyRect">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item.icon"
              >
                <template v-slot:error> <i class="iconfont iconadd" @click="onActivity1" /></template>
              </van-image>
            </div>
          </div>
          {{ item.name }}
        </van-col>

      </van-row>
    </div>
    <div v-if="!data.isFinish || !data.myself">
      <img src="/img/hbup.jpg" class="back">
      <div class="downRect">
        <img src="/img/hbdown.jpg" class="back">
        <div class="Body">
          <div class="title">活动规则</div>
          1.参与条件：潜水员<br>
          2.参与方式：1人参与，邀请2位潜水员即可成功组队<br>
          3.可以在展会现场获取或者选择邮寄<br>
          4.组队成功礼品：3人组队成功，每人获得<span style="font-weight: 700;">潜水员叮叮棒一根（价值58元）</span>；队伍不足3人，组队失败；队伍超过3人，第4人需另组队伍。<br>
          <div class="title">活动说明</div>
          1.每人仅限参与一次活动，每人仅限获得一根叮叮棒<br>
          2.组队发起人即是队长，不能弃队，只能找寻队员<br>
          3.礼品叮叮棒颜色随机，可以现场领取或选择邮寄<br>
          4.可以在展会现场获取或者选择邮寄<br>
          5.邮寄叮叮棒在成功组队后30天内发出<br>
          <div class="emptyRect" />
        </div>
      </div>
      <div class="downButton">
        <van-button type="info" class="blue" @click="onActivity">{{ ActivityTitle }}</van-button>
      </div>
    </div>
    <div v-else>
      <div class="commodityIcon">
        <img src="/img/ddb.jpg">
      </div>
      <div class="downButton">
        <van-button type="info" @click="onGetGift">领取奖励</van-button>
      </div>
    </div>
    <van-popup v-model="showTypeSelect" position="bottom">
      <van-picker
        show-toolbar
        title="选择领奖方式"
        :columns="typeSelectList"
        @cancel="onCancelType"
        @confirm="onConfirmType"
      />
    </van-popup>
    <van-dialog
      v-model="showQrCode"
      title="请向SSI展台工作人员出示二维码领奖"
      show-cancel-button
    >
      <img class="qrCode" :src="giftQrcode">
    </van-dialog>
    <wxShare v-model="showShare" :title="shareUrlTitle" desc="组队领叮叮棒，人手一根!" timeline="SSI见面礼，免费领叮叮棒，人手一根" :url="shareUrl" :img="shareIcon" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { GetSelfUrl } from '@/utils/request'
import { getToken } from '@/utils/auth'
import { getUrlKey, initPage, MyNotify } from '@/utils/base'
import { Button, Image, Popup, Picker, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import wxShare from '@/components/wxShare'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    TopBar,
    wxShare
  },
  data() {
    return {
      shareUrlTitle: undefined,
      shareUrl: undefined,
      shareIcon: undefined,
      data: {
        isFinish: false,
        declaration: '无塑料未来',
        memberList: [
          { name: '请加入', icon: '' }, { name: '请加入', icon: '' }, { name: '请加入', icon: '' }
        ]
      },
      teamId: undefined,
      showShare: false,
      pageTitle: '我的小队',
      backurl: '/activity/group',
      ActivityTitle: '立刻参加',
      showTypeSelect: false,
      showQrCode: false,
      giftQrcode: undefined,
      typeSelectList: [
        { text: 'ADEX现场领取 上海7月 5至 7日', value: 'qr' },
        { text: 'ADEX现场领取 北京7月12至14日', value: 'qr' },
        { text: '邮寄', value: 'send' }
      ]
    }
  },
  mounted() {
    initPage(true)
    console.log('进入')
    if (!this.myFullTeam) {
      document.getElementsByTagName('body')[0].className = 'activeBacl'
    }
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    initPage(true)
    console.log('我设置了shareIcon的值')
    this.shareIcon = GetSelfUrl() + 'img/adex2019ShareIcon.jpg'
    this.data.isFinish = false
    if (!this.data.isFinish) {
      document.getElementsByTagName('body')[0].className = 'activeBacl'
    } else {
      document.body.removeAttribute('class', 'activeBacl')
    }
    var code = getUrlKey('c')
    if (code) {
      Cookies.set('activityCardKey_', code)
      this.teamId = code
    } else {
      this.teamId = Cookies.get('activityCardKey_')
    }
    // var url = getUrlKey('backurl')
    // if (url !== null) {
    //   this.backurl = url
    // }
    request({
      url: '/Activity/GetCardTeam',
      method: 'get',
      params: {
        id: this.teamId
      }
    }).then(Response => {
      if (!Response.success) {
        return
      }
      this.data = Response.data
      if (this.data.myself === null) {
        this.data.myself = undefined
      }
      this.shareUrlTitle = this.data.memberList[0].name + '的潜水小分队'
      this.shareUrl = GetSelfUrl() + 'activity/groupTeams?c=' + this.data.teamId
      if (this.data.myself) {
        this.pageTitle = '我的小队'
        this.ActivityTitle = '邀请好友加入'
      } else {
        this.pageTitle = '第' + this.data.teamId + '小分队'
        this.ActivityTitle = '立刻参加'
      }
      for (var i = this.data.memberList.length; i < 3; i++) {
        this.data.memberList.push({ name: '请加入', icon: '' })
      }
      if (!this.data.isFinish || !this.data.myself) {
        document.getElementsByTagName('body')[0].className = 'activeBacl'
      } else {
        document.body.removeAttribute('class', 'activeBacl')
      }
    })
    this.initWeChatShare()
  },
  methods: {
    initWeChatShare() {
    },
    doShare() {
      this.showShare = true
    },
    onActivity() {
      if (this.data.myself) {
        this.doShare()
      } else {
        this.$router.replace('/activity/groupReg')
      }
    },
    onActivity1() {
      this.$router.replace('/activity/groupReg')
    },
    onGetGift() {
      var my = this
      if (!this.data.myself) {
        MyNotify('error', '尚未完成拼团')
        return
      }
      if (!this.data.myself.isApprove) {
        Dialog.alert({
          title: '潜水员身份审核中',
          message: '您的潜水员身份尚未通过认证，暂时无法领取奖品!' })
        return
      }
      switch (this.data.myself.type) {
        case 'QRCODE':
          Dialog.alert({
            title: '已领奖',
            message: '您已经在现场通过扫码形式领取奖品，无法重复领取!' })
          return
        case 'ORDER':
          Dialog.confirm({
            title: '已领奖',
            message: '您已经通过邮寄形式领取奖品，如现在需要到现场领奖请取消订单后在领奖!查看订单?' })
            .then(() => {
              this.$router.replace('/store/orderInfo/' + my.data.myself.OrderId + '?backurl=/activity/groupTeams')
            })
          return
        case 'ORDERSEND':
          Dialog.confirm({
            title: '已领奖',
            message: '您已经通过邮寄形式领取奖品，无法重复领取!查看订单?' })
            .then(() => {
              this.$router.replace('/store/orderInfo/' + my.data.myself.OrderId + '?backurl=/activity/groupTeams')
            })
          return
      }
      this.showTypeSelect = true
    },
    onCancelType() {
      this.showTypeSelect = false
    },
    onConfirmType(value) {
      this.showTypeSelect = false
      if (value.value === 'qr') {
        this.showQrCode = true
        var selfUrl = GetSelfUrl() + 'activity/groupCheck'
        this.giftQrcode = this.data.myself.qrCode + '&token=' + getToken().token + '&baseUrl=' + encodeURIComponent(selfUrl)
      } else {
        this.$router.replace('/store/addressList?type=activityCard&backurl=/activity/groupTeams')
      }
    },

    onShare() {
      if (this.data.myself) {
        this.doShare()
      } else {
        this.$router.replace('/activity/group')
      }
    }
  }
}
</script>
<style scoped>
.downRect{
  position: relative;
}
.Body{
  padding: 0 2em;
  margin-top: 1em;
  color: #fff;
  position: absolute;;
  left: 0;
  right: 0;
  top:0;
  line-height: 1.5em;
  font-size: 0.9em;
}
.title{
  font-size: 1.1em;
  font-weight: 700;
  margin: 2em 0 1em 0;
}
.emptyRect{
  height: 6em;
}

.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}

.teamRect{
    background-color: #1E2430;
    position: relative;
    padding: 1em 1em;
    color: #fff;
}
.teamRect .sanjiao{
    position: absolute;
     border-width: 1em;
    border-style: solid;
    border-color:#1E2430 transparent transparent transparent;
    bottom: -2em;
    left: 50%;
    margin-left: -0.8em;
}
.teamRect .about
{
    font-size: 0.9em;
}
.teamRect .talk{
    margin: 0.5em 0;
    padding: 0 0.5em;
    text-align: center;
    line-height: 2.2em;
    font-size: 1.3em;
    background-color: #0092FA;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.imgRect{
    position: relative;
}
.imgRect img{
    width: 100%;
    height: auto;
    vertical-align:top;
}
.imgRect .imgEmptyRect{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
}
.iconRect{
    margin: 1em 0;
    text-align:center;
    font-size: 0.8em;
    line-height: 2.5em;
    color: #CCC;
}
.downButton{
  position: fixed;
  bottom: 1.5em;
  padding: 0 2em;
  left: 0;
  right: 0;
  height: 42px;
}
.downButton button{
  width: 100%;
}
.downButton .blue{
  background-color: #0092FA;
  border: #0092FA;
}
.commodityIcon{
    padding: 0 2em;
    margin: 3em 0 6em 0;
}
.commodityIcon img{
    width:100%;
}
.qrCode{
 width: 100%;
  /* box-sizing: border-box;
 padding: 2em; */
}
</style>
